import { ChatEngine } from "react-chat-engine";
import LoginForm from './components/LoginForm';
import "./App.css";
import ChatFeed from './components/ChatFeed';









const App = () => {

  

  if (!localStorage.getItem('username')) return <LoginForm />

  return (
    <ChatEngine
      height="100vh"
      projectID="52e6936c-bdd4-431a-a6e7-c60aaa346657"
      userName={localStorage.getItem('username')}
      userSecret={localStorage.getItem('password')}

      renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
      onNewMessage={() => new Audio('https://chat-engine-assets.s3.amazonaws.com/click.mp3').play()}
      
      
      
      />
     
      );
   
    };
  
    


export default App;

